import hash from "object-hash";
import type { Awaitable } from "~/services/RedisCacheService";
import RedisCacheService from "~/services/RedisCacheService";

export const useCacheService = () => {
  const { isDevMode } = useRuntimeConfig().public;
  RedisCacheService.runtimeConfig = useRuntimeConfig();

  const SHORT_TTL = 5 * 60;
  const LONG_TTL = 30 * 60;

  const getFormerKey = (
    serviceName: string,
    key: string,
    o?: unknown
  ): string => {
    const appnName = "rt-2023";

    if (o) {
      if (typeof o === "object") {
        return `${appnName}:${serviceName}:${key}:${hash(o)}`;
      }
      return `${appnName}:${serviceName}:${key}:${o}`;
    } else {
      return `${appnName}:${serviceName}:${key}`;
    }
  };

  /**
   *
   * @param key
   * @param fn Function fired after entry has expired with key and value passed
   * @param ttl Time in seconds
   * @returns
   */
  const cache = async <T>(
    key: string | number,
    fn: () => Awaitable<T>,
    ttl: number = SHORT_TTL
  ): Promise<T> => {
    if (isDevMode.toString() === "true") return fn();

    return RedisCacheService.Instance.cache(key, fn, ttl);
  };

  return {
    getFormerKey,
    cache,
    SHORT_TTL,
    LONG_TTL
  };
};
